const query = gql`
  fragment LandingPageFields on LandingPageRecord {
    id
    name
    heading
    preamble
    onPageNavigation
    slug
    imageGradient
    showMenu
    headerImage {
      id
      url: url(imgixParams: { auto: compress })
    }
    headerCta {
      ... on CtaBlockRecord {
        buttonText
        url
      }
    }
    mainImage {
      id
      mobileImage: url(
        imgixParams: {
          fm: jpg
          fit: crop
          crop: [faces, edges]
          w: 375
          h: 400
          auto: compress
        }
      )
      responsiveImage(
        imgixParams: {
          fm: jpg
          fit: crop
          crop: [faces, edges]
          w: 600
          auto: compress
        }
      ) {
        srcSet
        sizes
        src
      }
    }
    partnerLogo {
      url: url(imgixParams: { h: 100 })
    }
    sections {
      heading
      background
      width
      sectionBlocks {
        __typename
        ... on TextBlockRecord {
          id
          bodyCopy
          centeredText
        }
        ... on ImageBlockRecord {
          image {
            id
            responsiveImage(
              imgixParams: { fit: crop, w: 986, auto: compress }
            ) {
              alt
              title
              src
              srcSet
              width
              height
            }
          }
          roundedCorners
          caption
        }
        ... on ListPageBlockRecord {
          id
          listItems {
            id
            image {
              id
              url: url(imgixParams: { fit: crop, w: 120, auto: compress })
            }
            heading
            body
          }
        }
        ... on ImageTextBlockRecord {
          id
          text
          image {
            url: url(imgixParams: { fit: crop, w: 484, auto: compress })
            width
            height
          }
          imagePosition
          textAlignment
          roundedCorners
        }
        ... on LinkableImageTextBlockRecord {
          id
          text
          image {
            url: url(imgixParams: { fit: crop, w: 484, auto: compress })
            width
            height
          }
          imagePosition
          textAlignment
          roundedCorners
          url
        }
        ... on CardBlockRecord {
          id
          heading
          body
          cta
          ctaLink
          image {
            url: url(imgixParams: { fit: crop, w: 484, auto: compress })
            width
            height
          }
        }
        ... on CardsBlockRecord {
          id
          displayAsCards
          cards {
            id
            heading
            image {
              id
              url(imgixParams: { fit: crop, fm: jpg, h: 284 })
              width
              height
            }
            body
          }
        }
        ... on CtaBlockRecord {
          buttonText
          url
        }
        ... on DownloadCtaBlockRecord {
          buttonText
          url
          downloadFileName
        }
        ... on SlideshowBlockRecord {
          id
          slides {
            id
            heading
            image {
              url(imgixParams: { fit: crop, w: 782, auto: compress })
            }
            body
          }
        }
        ... on AppButtonBlockRecord {
          appButtons {
            buttonText
            color
            useOfficialButton
          }
        }
        ... on TextHeroRecord {
          heading
          body
          backgroundImage {
            mobileImage: url(imgixParams: { fm: jpg, auto: compress, rot: 90 })
            responsiveImage(
              imgixParams: {
                fm: jpg
                fit: crop
                crop: [faces, edges]
                w: 600
                auto: compress
              }
            ) {
              srcSet
              sizes
              src
            }
          }
          image {
            url(
              imgixParams: { fit: crop, crop: [faces, edges], auto: compress }
            )
            height
            width
          }
          mobileImage {
            url(
              imgixParams: { fit: crop, crop: [faces, edges], auto: compress }
            )
            height
            width
          }
          textColor
        }
        ... on NumberedCardsBlockRecord {
          id
          cards {
            id
            heading
            image {
              id
              url(imgixParams: { fit: crop, fm: jpg })
              width
              height
            }
            body
          }
        }
        ... on VideoBlockRecord {
          id
          videos {
            embeddedMedia {
              id: providerUid
              url
              height
              width
            }
          }
        }
        ... on QuoteHeroRecord {
          heading
          quote
          quotee
          backgroundImage {
            mobileImage: url(
              imgixParams: {
                fm: jpg
                auto: compress
                ar: "3:4"
                fit: crop
                crop: [faces, edges]
              }
            )
            responsiveImage(
              imgixParams: {
                fm: jpg
                fit: crop
                crop: [faces, edges]
                w: 1200
                auto: compress
              }
            ) {
              srcSet
              sizes
              src
            }
          }
        }
        ... on NewsBlockRecord {
          news {
            heading: longHeading
            text: longText
            image {
              url
            }
            imageBackground {
              red
              green
              blue
            }
            imageAlignment
            publishedAt: _publishedAt
            ctaLink
          }
        }
        ... on ExternalLinksBlockRecord {
          links {
            id
            image {
              url
            }
            text
            link
            background {
              hex
            }
            linkColor {
              hex
            }
          }
        }
        ... on WidgetRecord {
          component
        }
      }
    }
  }

  query LandingPage($slug: String!, $locale: SiteLocale) {
    page: landingPage(filter: { slug: { eq: $slug } }, locale: $locale) {
      ...LandingPageFields
    }
    fallback: landingPage(filter: { slug: { eq: $slug } }, locale: en) {
      ...LandingPageFields
    }
  }
`

const queryAll = () => `

`

module.exports = {
  query,
  queryAll,
}
